import { useSelector } from "react-redux";
import { useMemo } from "react";
import {
  getPages,
  getOffset,
  selectSearchIsNewPage,
  selectSearchIsInitialLoading,
  selectSearchIsPagingBackward,
  selectSearchShowLoadMore,
  selectSearchShowLoadPrevious,
  selectSearchTileToFocus
} from "../../../../../state/modules/search";
import { isErrorOfTypeServer as getIsErrorOfTypeServer } from "../../../../../state/modules/error";
import Results from "./Results";
import { getCategoryTreatments } from "../../../../../state/modules/category";
import { getViewportCategory } from "../../../../../state/modules/layout/selectors";

const ConnectedResults = props => {
  const pages = useSelector(getPages);
  const offset = useSelector(getOffset);
  const isErrorOfTypeServer = useSelector(getIsErrorOfTypeServer);
  const isNewPage = useSelector(selectSearchIsNewPage);
  const isLoading = useSelector(selectSearchIsInitialLoading);
  const isLoadingPrevious = useSelector(selectSearchIsPagingBackward);
  const showLoadMore = useSelector(selectSearchShowLoadMore);
  const showLoadPrevious = useSelector(selectSearchShowLoadPrevious);
  const tileToFocus = useSelector(selectSearchTileToFocus);
  const treatments = useSelector(getCategoryTreatments);
  const viewportCategory = useSelector(getViewportCategory);

  const memoizedProps = useMemo(
    () => ({
      ...props,
      pages,
      isErrorOfTypeServer,
      isLoading,
      isNewPage,
      isLoadingPrevious,
      showLoadMore,
      showLoadPrevious,
      tileToFocus,
      offset,
      treatments,
      viewportCategory
    }),
    [
      props,
      pages,
      isErrorOfTypeServer,
      isLoading,
      isNewPage,
      isLoadingPrevious,
      showLoadMore,
      showLoadPrevious,
      tileToFocus,
      offset,
      treatments,
      viewportCategory
    ]
  );

  return <Results {...memoizedProps} />;
};

export default ConnectedResults;
